import React from 'react';
import { useFormContext } from 'react-hook-form';
import ZHLPaymentDonutChart from '../PaymentDonutChart/PaymentDonutChart.js';
import { useLastValidPayemntValues, calculateMonthlyMIP } from './VALoanCalculator.utils.js';

function VALoanCalculatorDonutChart(isFHAEnabled) {
  var form = useFormContext();
  var lastValidValues = useLastValidPayemntValues(form);
  var chartDataProps = {
    monthlyPayment: lastValidValues.calculations.monthlyPayment,
    monthlyPI: lastValidValues.calculations.monthlyPI,
    monthlyPropertyTax: lastValidValues.fields.includeTaxesInsurance ? lastValidValues.calculations.monthlyPropertyTax : 0,
    monthlyHomeownersInsurance: lastValidValues.fields.includeTaxesInsurance ? lastValidValues.calculations.monthlyHomeownersInsurance : 0,
    monthlyPMI: 0,
    monthlyHOA: lastValidValues.calculations.monthlyHOA,
    monthlyMIP: isFHAEnabled.isFHAEnabled && lastValidValues.fields.includeMIP ? calculateMonthlyMIP(lastValidValues.fields.homePrice - lastValidValues.fields.downPayment, lastValidValues.fields.homePrice, lastValidValues.fields.loanProgram) : 0,
    isFHAEnabled: isFHAEnabled
  };
  return /*#__PURE__*/React.createElement(ZHLPaymentDonutChart, chartDataProps);
}

export { VALoanCalculatorDonutChart as default };
